export function concatenar(separador, ...valores) {
  return valores.filter((v) => v != null && v !== '').join(separador)
}
